<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">New Contact</h1>
                <div @click="hideNewContactModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="bg-white p-4">
                <form class="p-6 border bg-gray-50">
                    <div class="px-2 py-3 flex flex-wrap gap-y-6 gap-x-8">
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="name">Name</label>
                            <input type="text" class="form-input" name="name" size="20" v-model="contact.name">
                            <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="floor">Type</label>
                            <select name="type" v-model="contact.type" class="mt-0 form-select max-w-fit">
                                <option value=""></option>
                                <option value="Broker">Broker</option>
                                <option value="Owner">Owner</option>
                                <option value="Property Manager">Property Manager</option>
                                <option value="Municipality">Municipality</option>
                                <option value="Developer">Developer</option>
                                <option value="Other">Other</option>
                            </select>
                            <div v-if="errors.type" class="form-error">{{ errors.type[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="title">Title</label>
                            <input type="text" class="form-input" name="title" size="20" v-model="contact.title">
                            <div v-if="errors.title" class="form-error">{{ errors.title[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label for="email">Email</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                    </svg>
                                </div>
                                <input
                                    v-model="contact.email"
                                    type="email"
                                    name="email"
                                    size="30"
                                    class="form-input w-full pl-10"
                                    placeholder="john@example.com" />
                            </div>
                            <div v-if="errors.email" class="form-error">{{ errors.email[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label for="phone">Phone</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg class="h-4 w-4 text-gray-400" fill="none" stroke-width="1.5" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                    </svg>
                                </div>
                                <input
                                    v-model="contact.phone"
                                    type="tel"
                                    name="phone"
                                    class="form-input w-full pl-9"
                                    placeholder="(555) 555-5555" />
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="extension">Ext.</label>
                            <input type="text" class="form-input" name="extension" size="6" v-model="contact.extension">
                            <div v-if="errors.extension" class="form-error">{{ errors.extension[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label for="cell">Cell</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg class="h-4 w-4 text-gray-400" fill="none" stroke-width="1.5" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                    </svg>
                                </div>
                                <input
                                    v-model="contact.cell"
                                    type="tel"
                                    name="cell"
                                    class="form-input w-full pl-9"
                                    placeholder="(555) 555-5555" />
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label for="fax">Fax</label>
                            <div class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg class="h-4 w-4 text-gray-400" fill="none" stroke-width="1.5" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                    </svg>
                                </div>
                                <input
                                    v-model="contact.fax"
                                    type="tel"
                                    name="fax"
                                    class="form-input w-full pl-9"
                                    placeholder="(555) 555-5555" />
                            </div>
                        </div>

                        <div class="w-full flex flex-col">
                            <label class="text-sm font-semibold" for="description">Comments</label>
                            <textarea class="w-full form-textarea" name="comment" rows="6" v-model="contact.comment" :v-text="contact.comment"></textarea>
                            <div v-if="errors.comment" class="form-error">{{ errors.comment[0] }}</div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="p-4 flex items-center justify-end bg-gray-100">
                <button class="btn btn-secondary mr-2" @click.prevent="hideNewContactModal">Close</button>
                <button class="btn btn-green" @click.prevent="createContact">
                    <span v-if="loading">
                        <inline-svg name="loading-button"></inline-svg>                                
                    </span>
                    <span v-if="! loading">Create Contact</span>
                </button>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            attachTo: {
                type: String,
                required: true
            },

            attachToId: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                contact: {
                    attachTo: this.attachTo,
                    attachToId: this.attachToId,
                },
                errors: '',
                loading: false           
            }
        },

        computed: {
            ...mapState(['sites']),
            ...mapState(['contacts']),
        },

        methods: {
            hideNewContactModal() {
                this.$modal.hide('new-contact');
            },

            createContact() {
                this.loading = true;

                axios.post('/contacts', this.contact)
                    .then((response) => {
                        this.contacts.all.push(response.data.contact);
                        this.contacts.filtered.push(response.data.contact);

                        this.$modal.hide('new-contact');

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>